import { createSlice } from "@reduxjs/toolkit";
import {
  createInterimAwardsAction,
  getInterimAwardsByCaseIDAction,
  updateInterimAwardsAction,
  deleteInterimAwardsAction,
} from "../../actions/InterimAwards/interimAwardsAction";

const initialState = {
  interimAwards: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const interimAwardsSlice = createSlice({
  name: "interimAwards",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInterimAwardsByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInterimAwardsByCaseIDAction.fulfilled, (state, action) => {
        state.loading = false;
        state.interimAwards = action.payload.InterimAwards || [];
      })
      .addCase(getInterimAwardsByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    // =========================================================================
    // CREATE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(createInterimAwardsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInterimAwardsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Interim Awards created successfully";
        state.interimAwards.push(action.payload.data);
      })
      .addCase(createInterimAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // UPDATE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(updateInterimAwardsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInterimAwardsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Interim Awards updated successfully";

        const index = state.interimAwards.findIndex(
          (o) => o.interimAwards_ID === action.payload.interimAwards_ID,
        );

        if (index !== -1) {
          state.interimAwards[index] = action.payload;
        }
      })
      .addCase(updateInterimAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(deleteInterimAwardsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteInterimAwardsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Interim Awards deleted successfully";

        state.interimAwards = state.interimAwards.filter(
          (o) => o.interimAwards_ID !== action.payload,
        );
      })
      .addCase(deleteInterimAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = interimAwardsSlice.actions;

export default interimAwardsSlice.reducer;
